import React, { PureComponent, Fragment } from "react";
import Form from "js/pages/Admin/Programa/Beneficio/SucursalBeneficio/Edit/MyForm.js";
import AppQraphQL from "js/graphql/resolvers/beneficio.resolver";
import { get } from "lodash";

class Edit extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: { estado: "ACTIVO" },
      disabled: null,
      idPrograma:
        parseInt(this.props.match.params.id, 10) ||
        this.props.match.params.idPrograma,
      idBeneficio:
        parseInt(this.props.match.params.idBeneficio, 10) ||
        this.props.match.params.idBeneficio,
      idSucursal:
        parseInt(this.props.match.params.idSucursal, 10) ||
        this.props.match.params.idSucursal,
      beneficio: "",
      errors: null
    };
  }

  async componentDidMount() {
    const { client } = this.props;
    const {
      match: {
        params: { edit }
      }
    } = this.props;
    const { idPrograma, idBeneficio, idSucursal } = this.state;

    const dataBeneficio = await client.query({
      query: AppQraphQL.queries.getBeneficioById,
      fetchPolicy: "network-only",
      errorPolicy: "all",
      variables: {
        idBeneficio: parseInt(idBeneficio, 10) || idBeneficio,
        idPrograma: parseInt(idPrograma, 10) || idPrograma
      }
    });
    const nombreBeneficio = get(
      dataBeneficio,
      "data.getBeneficio.itemsPagina[0].nombre",
      null
    );

    this.setState({
      beneficio: nombreBeneficio
    });

    if (idSucursal !== "new") {
      await client
        .query({
          query: AppQraphQL.queries.getSucursalBeneficioById,
          fetchPolicy: "network-only",
          variables: {
            idSucursal
          }
        })
        .then(res =>
          this.setState({
            initialValues: {
              ...res.data.getBeneficioSucursales.itemsPagina[0],
              idPais:
                (res.data.getBeneficioSucursales.itemsPagina[0].pais &&
                  parseInt(
                    res.data.getBeneficioSucursales.itemsPagina[0].pais.idPais
                  )) ||
                (res.data.getBeneficioSucursales.itemsPagina[0].pais &&
                  res.data.getBeneficioSucursales.itemsPagina[0].pais.idPais),
              idZona:
                (res.data.getBeneficioSucursales.itemsPagina[0].zona &&
                  parseInt(
                    res.data.getBeneficioSucursales.itemsPagina[0].zona.idZona
                  )) ||
                (res.data.getBeneficioSucursales.itemsPagina[0].zona &&
                  res.data.getBeneficioSucursales.itemsPagina[0].zona.idZona),
              idLocalidad:
                (res.data.getBeneficioSucursales.itemsPagina[0].localidad &&
                  parseInt(
                    res.data.getBeneficioSucursales.itemsPagina[0].localidad
                      .idLocalidad
                  )) ||
                (res.data.getBeneficioSucursales.itemsPagina[0].localidad &&
                  res.data.getBeneficioSucursales.itemsPagina[0].localidad
                    .idLocalidad)
            },
            disabled: !(edit === "edit")
          })
        );
    }
  }

  async submit(values) {
    const {
      client,
      history,
      match: {
        params: { id, idBeneficio, idSucursal }
      }
    } = this.props;

    await client
      .mutate({
        mutation:
          idSucursal === "new"
            ? AppQraphQL.mutations.createBeneficioSucursal
            : AppQraphQL.mutations.updateBeneficioSucursal,
        variables: {
          sucursal:
            idSucursal === "new"
              ? {
                  idPrograma: parseInt(id, 10),
                  idBeneficio: parseInt(idBeneficio, 10),
                  nombre: values.nombre,
                  telefono: values.telefono,
                  direccion: values.direccion,
                  idPais: parseInt(get(values, "idPais", null), 10),
                  idZona: parseInt(get(values, "idZona", null), 10),
                  idLocalidad: parseInt(get(values, "idLocalidad", null), 10),
                  notas: values.notas,
                  orden: parseInt(values.orden, 10) || values.orden
                }
              : {
                  idPrograma: parseInt(id, 10),
                  idBeneficio: parseInt(idBeneficio, 10),
                  idSucursal: parseInt(idSucursal, 10),
                  estado: values.estado,
                  nombre: values.nombre,
                  telefono: values.telefono,
                  direccion: values.direccion,
                  idPais: parseInt(get(values, "idPais", null), 10),
                  idZona: parseInt(get(values, "idZona", null), 10),
                  idLocalidad: parseInt(get(values, "idLocalidad", null), 10),
                  notas: values.notas,
                  orden: parseInt(values.orden, 10) || values.orden
                }
        }
      })
      .then(res => {
        const message = "Sucursal grabada correctamente";
        this.props.openNotification(message);
        history.push(
          `/admin/programa/${id}/beneficios/${idBeneficio}/sucursales-beneficio`
        );
      })
      .catch(e => {
        this.setState({ errors: e });
        return false;
      });
  }

  render() {
    return (
      <Fragment>
        <Form
          id={this.state.idPrograma}
          idBeneficio={this.state.idBeneficio}
          idSucursal={this.state.idSucursal}
          errors={this.state.errors}
          disabled={this.state.disabled}
          initialValues={this.state.initialValues}
          onSubmit={this.submit.bind(this)}
          beneficio={this.state.beneficio}
        />
      </Fragment>
    );
  }
}

export default Edit;
